import { render, staticRenderFns } from "./addPartnerPool.vue?vue&type=template&id=8fdfc9e4"
import script from "./addPartnerPool.vue?vue&type=script&lang=js"
export * from "./addPartnerPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports